import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { hasToken, clearToken } from './api/scout';
import Header from './components/Header';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import CSATReview from './pages/CSATReview';
import Investigate from './pages/Investigate';
import TicketDetail from './pages/TicketDetail';

function Atmosphere() {
  return (
    <div className="atmosphere">
      <div className="atmo-grid" />
      <div className="atmo-blob b1" />
      <div className="atmo-blob b2" />
      <div className="atmo-blob b3" />
      <div className="atmo-radar" />
      <div className="atmo-mountains" />
    </div>
  );
}

export default function App() {
  const [authed, setAuthed] = useState(hasToken());

  useEffect(() => {
    function handleUnauth() {
      setAuthed(false);
    }
    window.addEventListener('scout-unauthorized', handleUnauth);
    return () => window.removeEventListener('scout-unauthorized', handleUnauth);
  }, []);

  function handleLogout() {
    clearToken();
    setAuthed(false);
  }

  return (
    <ThemeProvider>
      {!authed ? (
        <Login onLogin={() => setAuthed(true)} />
      ) : (
        <BrowserRouter>
          <div className="min-h-screen" style={{ position: 'relative' }}>
            <Atmosphere />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <Header onLogout={handleLogout} />
              <main>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/csat" element={<CSATReview />} />
                  <Route path="/investigate" element={<Investigate />} />
                  <Route path="/ticket/:id" element={<TicketDetail />} />
                </Routes>
              </main>
            </div>
          </div>
        </BrowserRouter>
      )}
    </ThemeProvider>
  );
}
